import React, { Component } from 'react';
import Modal from '@material-ui/core/Modal';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup';
import ToggleButton from '@material-ui/lab/ToggleButton';

import Pyramid from './inputs/Pyramid';
import Qty from './inputs/Qty';
import OneRM from './inputs/OneRM';
import EachSide from './inputs/EachSide';
import Timer from './inputs/Timer';
import TempoTraining from './inputs/TempoTraining';
import { COLORS } from '../../styles/colors';
import ModalHeading from '../ModalHeading';
import SaveOrCancel from '../SaveOrCancel';
import { AlertJsMessage } from './../../helpers.js'
import { inCircuit } from './_dndlogic';

const defaultFormData = {
	exerciseId: 0,
	sets: 1,
	unit: 'reps',
	qty: '',
	repsToFailure: false,
	pyramidReps: '',
	rm: '',
	wp: '',
	rpe: '',
	eachSide: false,
	tempo: '',
	rest: null,
	workoutId: -1,
	notes: '',
	time: '',
	isTimer: true,
	restOption: 'secondsOfRest',
};

const VISIBLE_METHOD_ELEMENTS = {
	reps: {
		pyramid: false,
		qty: true,
		sets: true,
		eachSide: true,
		repMax: true,
		tempo: true,
	},
	seconds: {
		pyramid: false,
		qty: true,
		sets: true,
		eachSide: true,
		repMax: true,
		tempo: true,
		isTimer: true,
	},
	yards: {
		pyramid: false,
		qty: true,
		sets: true,
		eachSide: true,
		repMax: true,
		tempo: true,
	},
	meters: {
		pyramid: false,
		qty: true,
		sets: true,
		eachSide: true,
		repMax: true,
		tempo: true,
	},
	repsToFailure: {
		pyramid: false,
		qty: false,
		sets: true,
		eachSide: true,
		repMax: true,
		tempo: true,
	},
	pyramidReps: {
		pyramid: true,
		qty: false,
		sets: true,
		eachSide: true,
		repMax: true,
		tempo: true,
	},
	pyramidSeconds: {
		pyramid: true,
		qty: false,
		sets: true,
		eachSide: true,
		repMax: true,
		tempo: true,
		isTimer: true
	},
	pyramidYards: {
		pyramid: true,
		qty: false,
		sets: true,
		eachSide: true,
		repMax: true,
		tempo: true,
	},
	pyramidMeters: {
		pyramid: true,
		qty: false,
		sets: true,
		eachSide: true,
		repMax: true,
		tempo: true,
	},
};

export class EditPlanModal extends Component {
	constructor(props) {
		super(props);
		this.state = {
			itemId: 0,
			unit: 'reps',
			formData: {},
			method: 'reps',
			visible: {
				pyramid: false,
				qty: true,
				sets: true,
				eachSide: true,
				repMax: true,
				tempo: true,
			},
		};
	}

	componentDidUpdate(prevProps) {
		if (this.props.item !== prevProps.item && this.props.item) {
			if (this.state.itemId !== this.props.item.id) {
				this.setFormData();
			}
		}
	}

	setFormData() {
		const { item } = this.props;
		if (item.planData) {
			this.setState({
				itemId: item.id,
				formData: { ...item.planData },
			});
		} else if (item.formData) {
			let formPyramaid = item.formData.pyramidReps;
			if (typeof formPyramaid === 'string') {
				formPyramaid = formPyramaid.split(',');
			}
			let pyramidReps =
				formPyramaid && formPyramaid.filter(x => x).length ? formPyramaid : '';
			let method = item.formData.unit;
			if (Array.isArray(pyramidReps)) pyramidReps = pyramidReps.toString();
			if (pyramidReps) {
				switch (item.formData.unit) {
					case 'reps':
						method = 'pyramidReps';
						break;
					case 'seconds':
						method = 'pyramidSeconds';
						break;
					case 'yards':
						method = 'pyramidYards';
						break;
					case 'meters':
						method = 'pyramidMeters';
						break;
					default:
						break;
				}
			}
			if (item.formData.repsToFailure) method = 'repsToFailure';
			this.setState(state => ({
				itemId: item.id,
				method: method || state.method,
				inCircuit: item.inCircuit,
				visible: VISIBLE_METHOD_ELEMENTS[method || state.method],
				formData: {
					...item.formData,
					pyramidReps,
					restOption: item.formData.rest === null ? 'needed' : 'secondsOfRest',
					sets: item.inCircuit
						? 1
						: item.formData.sets === 0
						? 1
						: item.formData.sets,
				},
			}));
		} else {
			this.setState({
				inCircuit: item.inCircuit,
				itemId: item.id ? item.id : -1,
				method: 'reps',
				visible: VISIBLE_METHOD_ELEMENTS['reps'],
				formData: { ...defaultFormData },
			});
		}
	}

	handleMethodChange = () => event => {
		const method = event.target.value;
		const { formData } = this.state;
		let unit = '';
		if (['reps', 'pyramidReps'].includes(method)) {
			unit = 'reps';
		}
		if (['seconds', 'pyramidSeconds'].includes(method)) {
			unit = 'seconds';
			formData.repsToFailure = false;
			formData.isTimer = true;
		}
		if (['yards', 'pyramidYards'].includes(method)) {
			unit = 'yards';
		}
		if (['meters', 'pyramidMeters'].includes(method)) {
			unit = 'meters';
		}
		this.setState({
			formData: {
				...formData,
				repsToFailure: method === 'repsToFailure',
				pyramidReps: method === 'repsToFailure' ? '' : formData.pyramidReps,
				unit,
				qty: '',
			},
			method: event.target.value,
			visible: VISIBLE_METHOD_ELEMENTS[event.target.value],
		});
	};
	handleChange = field => event => {
		if (event.target) {
			switch (field) {
				case 'eachSide':
					this.setState({
						...this.state,
						formData: {
							...this.state.formData,
							eachSide: event.target.checked,
						},
					});
					break;
				case 'sets':
					this.setState({
						...this.state,
						selectedRepType:
							event.target.value < 1 ? '' : this.state.selectedRepType,
						pyramid: [0, 0, 0, 0, 0],
						formData: {
							...this.state.formData,
							[field]: event.target.value,
						},
					});
					break;
				case 'rest':
					if (/[^0-9]/g.test(event.target.value)) {
						this.setState({
							...this.state,
							formData: {
								...this.state.formData,
								[field]: this.state.formData[field],
							},
						});
					} else {
						this.setState({
							...this.state,
							formData: {
								...this.state.formData,
								[field]: event.target.value,
							},
						});
					}
					break;
				default:
					this.setState({
						...this.state,
						formData: {
							...this.state.formData,
							[field]: event.target.value,
						},
					});
			}
		}
	};
	editFormData(field, data) {
		let { formData } = this.state;
		if (field === 'rm' || field === 'wp'  || field === 'rpe' || field === 'qty') {
			if(data==='-') {
				data = '';
			}
			let valid = /^\d*\-?(?:\d{1,2})?$/;
			if(formData.unit === 'seconds') {
				valid = new RegExp('^[0-9]*$');
			}
			formData[field] = !valid.test(data) ? formData[field] : data;
		} else {
			formData[field] = data;
		}
		if (field === 'rm') {
			formData.wp = '';
			formData.rpe = '';
		}
		if (field === 'rpe') {
			formData.wp = '';
			formData.rm = '';
		}
		if (field === 'wp') {
			formData.rpe = '';
			formData.rm = '';
		}
		if (field === 'qty') formData.pyramidReps = '';
		this.setState({ formData });
	}

	validatePyramidReps(pyramidReps, sets) {
		if (pyramidReps && typeof pyramidReps === 'string') {
			const pyramids = pyramidReps
				.split(',')
				.filter(rep => Boolean(Number(rep)));
			return pyramids.length === Number(sets);
		}
		return false;
	}

	validateTempoTraining(tempo) {
		if (tempo && typeof tempo === 'string') {
			const value = tempo.split(',').filter(temp => temp);
			return value.length === 4;
		}
		return false;
	}

	validate() {
		const { save, item } = this.props;
		const {
			formData,
			formData: {
				sets,
				unit,
				qty,
				pyramidReps,
				repsToFailure,
				tempo,
				rest,
				restOption,
			},
			method,
		} = this.state;
		if (qty) {
			formData.qty = qty;
		}
		if (
			item.id.includes('edit') &&
			['reps', 'seconds', 'yards', 'meters'].includes(method) &&
			!qty
		) {
			AlertJsMessage(
				'Please make sure to select the proper work method and insert a number to quantify the reps, seconds,  yards or meters.'
			);
			return;
		}
		if (
			item.id.includes('edit') &&
			['reps', 'seconds', 'yards', 'meters'].includes(method) &&
			qty
		) {
			const qtyArr = qty.split('-');
			if(qtyArr.length === 2) {
				if(parseInt(qtyArr[0]) >= parseInt(qtyArr[1])) {
					AlertJsMessage(
						'Please make sure, second quantify number will be greater than first one.'
					);
					return;
				}
			}
		}

		
		if (!sets && !item.inCircuit) {
			AlertJsMessage('lease select a number of sets before saving.');
		} else if (!unit && !repsToFailure) {
			AlertJsMessage('lease select a unit before saving.');
		} else if (
			!repsToFailure &&
			['reps', 'seconds', 'yards', 'meters'].includes(method) &&
			!!!formData.qty
		) {
			AlertJsMessage(
				'Please make sure to select the proper work method and insert a number to quantify the reps, seconds, or yards.'
			);
		} else if (
			!repsToFailure &&
			['pyramidReps', 'pyramidSeconds', 'pyramidYards', 'pyramidMeters'].includes(method) &&
			(!pyramidReps || !this.validatePyramidReps(pyramidReps, sets))
		) {
			AlertJsMessage('lease insert a number to quantify the units in every set.');
		} else if (restOption !== 'needed' && rest < 0) {
			AlertJsMessage('lease enter rest seconds');
		} else if (tempo && !this.validateTempoTraining(tempo)) {
			AlertJsMessage('lease insert a number in each tempo training field.');
		} else {
			let qty = formData.qty;
			if(qty.slice(-1) === '-') {
				qty = qty.slice(0, -1)
			}
			formData.qty = qty;
			if(unit !== 'seconds' && unit !== 'pyramidSeconds') {
				formData['isTimer'] = false;
			}
			save(formData);
		}
	}

	onModalClose = () => {
		const { item, remove, close } = this.props;
		if (!item.added) {
			remove();
			close();
		} else {
			close();
		}
	};

	render() {
		const { formData, visible } = this.state;
		const { item } = this.props;
		if (!item) {
			return null;
		}
		if (item.child || item.parent) {
			return null;
		}
		if (item.type !== 'plan') {
			return null;
		}

		if (item.circuitData && item.circuitData.emom !== 0) {
			visible.tempo = false;
		} else {
			visible.tempo = true;
		}

        let METHODS = [
			{ value: 'reps', text: 'Reps' },
			{ value: 'seconds', text: 'Seconds' },
			{ value: 'yards', text: 'Yards' },
			{ value: 'meters', text: 'Meters' },
			{ value: 'repsToFailure', text: 'Reps To Failure' }
		];

		if(!item.inCircuit) {
			METHODS.push({ value: 'pyramidReps', text: 'Pyramid Reps' },
			{ value: 'pyramidSeconds', text: 'Pyramid Seconds' },
			{ value: 'pyramidYards', text: 'Pyramid Yards' },
			{ value: 'pyramidMeters', text: 'Pyramid Meters' });
		}

		
		return (
			<Modal
				className="modal show"
				open={item ? true : false}
				onClose={this.onModalClose}
			>
				<div className="modalBody modal-content">
					<ModalHeading
						text={`Prescription for ${item ? item.content : ''}`}
						closeModal={this.onModalClose}
					/>
					<div className="modalContent">
						<div style={{ width: '100%', display: 'flex' }}>
							{!item.inCircuit && (
								<div style={{ width: 65, marginRight: 10 }}>
									<TextField
										label={`Sets`}
										select
										value={formData.sets}
										onChange={this.handleChange('sets')}
										margin="dense"
										variant="outlined"
										placeholder="0"
									>
										{Array.apply(null, { length: 21 }).map((val, key) => (
											<MenuItem key={key} value={key}>
												{key ? key : '0'}
											</MenuItem>
										))}
									</TextField>
								</div>
							)}
							<div style={{ width: 180, marginRight: 10 }}>
								<TextField
									inputRef={ref => {
										this.methodPick = ref;
									}}
									select
									label="Work Method"
									value={this.state.method}
									onChange={this.handleMethodChange()}
									margin="dense"
									variant="outlined"
								>
									{METHODS.map(method => (
										<MenuItem key={method.value} value={method.value}>
											{method.text}
										</MenuItem>
									))}
								</TextField>
							</div>
							<div>
								{visible.pyramid ? (
									<div
										style={{
											width: 500,
											overflow: 'auto',
											whiteSpace: 'nowrap',
											paddingTop: 5,
											bottom: 5,
											position: 'relative',
										}}
									>
										<Pyramid
											data={formData.pyramidReps}
											changeField={data =>
												this.editFormData('pyramidReps', data)
											}
											sets={formData.sets}
										/>
									</div>
								) : null}
								{visible.qty ? (
									<Qty
										style={{ width: 50 }}
										curQty={formData.qty}
										unitName={'Total ' + this.state.method}
										changeField={data => this.editFormData('qty', data)}
									/>
								) : null}
							</div>
						</div>

						<div style={{ width: '100%', marginBottom: 10 }}>
							<span>Rest Interval</span>
							<div style={{ display: 'flex' }}>
								<ToggleButtonGroup
									style={{ width: 304 }}
									value={this.state.formData.restOption}
									onChange={(event, value) =>
										this.setState(state => ({
											formData: {
												...state.formData,
												restOption: value ? value : state.formData.restOption,
												rest:
													value === 'needed' ? null : state.formData.rest || 0,
											},
										}))
									}
									exclusive
								>
									<ToggleButton
										style={{ marginRight: 10 }}
										value="needed"
										selected={this.state.formData.restOption === 'needed'}
									>
										Rest As Needed
									</ToggleButton>
									<ToggleButton
										value="secondsOfRest"
										selected={
											this.state.formData.restOption === 'secondsOfRest'
										}
									>
										Seconds Of Rest
									</ToggleButton>
								</ToggleButtonGroup>
								<div style={{ width: 130, marginLeft: 10 }}>
									{this.state.formData.restOption === 'secondsOfRest' ? (
										<TextField
											label="Seconds"
											value={formData.rest}
											onChange={this.handleChange('rest')}
											margin="dense"
											variant="outlined"
											type="text"
											inputProps={{ maxLength: 5 }}
										/>
									) : null}
								</div>
							</div>
						</div>

						<div style={{ width: '100%', marginBottom: 10 }}>
							<span>Additional Options</span>
							<div
								style={{
									backgroundColor: COLORS.greyFour,
									boxShadow: `-25px 0px 0px 0px ${COLORS.greyFour}, 25px 0px 0px 0px ${COLORS.greyFour}`,
								}}
							>
								{visible.eachSide ? (
									<EachSide
										eachSide={formData.eachSide}
										changeField={val => this.editFormData('eachSide', val)}
									/>
								) : null}
								{visible.repMax ? (
									<OneRM
										rm={formData.rm}
										wp={formData.wp}
										rpe={formData.rpe}
										changeField={(type, val) => this.editFormData(type, val)}
									/>
								) : null}
								
								{ visible.tempo ? (
									<TempoTraining
										tempo={formData.tempo}
										changeField={val => this.editFormData('tempo', val)}
									/>
								) : null}
								{visible.isTimer ? (
									<Timer
										isTimer={formData.isTimer}
										changeField={val => this.editFormData('isTimer', val)}
									/>
								) : null}
							</div>
						</div>
						<div>
						<div style={{ width: '100%', marginBottom: 10 }}>
							<span><strong>Additional Notes:</strong><i> Input notes or instructions for your client to see on this exercise.</i></span>
								<div style={{ width: 600, marginRight: 10 }}>
								<TextField
										style={{ maxWidth: 600, marginTop: 10, marginRight: 10 }}
										label="Notes"
										value={formData.notes}
										type="text"
										onChange={this.handleChange('notes')}
										margin="dense"
										variant="outlined"
									/>
							</div>
						</div>
							<SaveOrCancel
								onSaveClick={() => this.validate()}
								onCancelClick={this.onModalClose}
							/>
						</div>
					</div>
				</div>
			</Modal>
		);
	}
}
export default EditPlanModal;



// WEBPACK FOOTER //
// ./src/components/workouts/EditPlanModal.js